export default __webpack_public_path__ + "images/eccb3508bb352ea356ff5bc216773804.png";